<div class="custom-filter-wrapper">
  <kl-loading *ngIf="showLoading" [loadingText]="loadingText"></kl-loading>
  <div class="col-md-12 col-sm-12 d-flex p-1 report-alert" *ngIf="alertShow">
    <kl-alert
      *ngIf="alertShow"
      [message]="alertMessage"
      type="error"
      [show]="alertShow"
      (onClose)="alertShow = false"
    ></kl-alert>
  </div>
  <div
    class="col-md-12 col-sm-12 d-flex header p-0"
    [class.active]="showFilterPanel"
  >
    <div
      class="filter-options menu col-md-3 col-sm-12 d-flex justify-content-between align-items-center p-2"
    >
      <div class="filters-title main-title">
        <h6 class="font-weight-light">
          <span class="title">
            {{ "filters" | translate }}
          </span>
        </h6>
      </div>
      <button
        class="btn btn-sm btn-greenish pull-right"
        (click)="applyReport()"
      >
        {{ "start_report" | translate }}
      </button>
    </div>

    <div
      class="filter-options border-left-0 col-sm-12"
      [ngClass]="showFilterPanel ? 'col-md-9' : 'col-md-12'"
    >
      <div class="filters-title main-title">
        <button class="btn btn-sm" (click)="showFilterPanel = !showFilterPanel">
          <i class="fal fa-bars"></i>
        </button>
        <h6 class="font-weight-light pl-2">
          <span class="title" style="font-weight: 600">{{
            report_title | translate
          }}</span>
        </h6>
      </div>
    </div>
  </div>
  <div
    class="custom-filter-inner col-md-12 col-sm-12 d-flex"
    [class.active]="showFilterPanel"
  >
    <div
      class="filter-options menu p-0 col-md-3 col-sm-12 filter-area"
      style="border-right: 1px solid rgb(237, 237, 237)"
    >
      <div class="search-filter-form">
        <div
          class="search-filter-form-content mt-0 border-top-0"
          style="max-height: 80vh !important; min-height: 80vh !important"
        >
          <div class="form-group row pb-2">
            <label for="report_view_type" class="col-md-12 col-sm-12">
              <span class="font-weight-light">{{
                "report_type" | translate
              }}</span>
            </label>
            <div class="col-md-12 col-sm-12">
              <p-dropdown
                [emptyFilterMessage]="'not_found' | translate"
                [options]="[
                  {
                    label: 'list_report' | translate,
                    value: ReportTypeEnum.GRID
                  },
                  {
                    label: 'matrix_report' | translate,
                    value: ReportTypeEnum.PIVOT
                  },
                  {
                    label: 'excel_report' | translate,
                    value: ReportTypeEnum.EXCEL_SHEET
                  }
                ]"
                [(ngModel)]="tableOrPivotType"
                (onChange)="onReportTypeChange.emit(tableOrPivotType)"
                name="report_view_type"
                id="report_view_type"
                [style]="{ width: '100%' }"
              >
              </p-dropdown>
            </div>
          </div>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    <div
      class="filter-values filter-options row m-0 col-sm-12 pl-1"
      [ngClass]="showFilterPanel ? 'col-md-9' : 'col-md-12'"
    >
      <div
        class="filter-values-content search-filter-form border-left-0 col-md-12 col-sm-12 p-0"
      >
        <kl-report
          *ngIf="showReport"
          [parentModuleName]="parentModuleName"
          [moduleName]="moduleName"
          [key]="key"
          [haveAggregate]="haveAggregate"
          [type]="type"
          [filter]="filter"
          [columns]="columns"
          [pivotColumns]="pivotColumns"
          [pivotRows]="pivotRows"
          [pivotValues]="pivotValues"
          [report_type]="report_type"
          [report_title]="report_title"
          [gridSettings]="gridSettings"
          [url]="url"
          (onError)="handleError($event)"
        >
        </kl-report>
      </div>
    </div>
  </div>
</div>
